if (!customElements.get("m-google-reviews")) {
  class MGoogleReviews extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector(".swiper-container");
      if (!container) return;
      const autoplay = this.dataset.autoplay !== "false";
      // fracionário como os carrosséis de produto: sempre há um card cortado à direita
      this.slider = new MinimogLibs.Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        threshold: 2,
        loop: true,
        autoplay: autoplay
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          1024: {
            slidesPerView: 3.15,
          },
        },
      });
    }
  }
  customElements.define("m-google-reviews", MGoogleReviews);
}
